// src/components/JarvislyModule/NoComponentSet.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useLocation } from 'react-router-dom';
import { Empty, Row } from 'antd';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const NoComponentSet = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const location = useLocation();

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Row justify="center">
      <div className="text-center text-muted mt-5">
        <Empty description={false} />
        <div className="text-center font-size-md mt-3">
          No <strong>'pages.init.component'</strong> found in module bootstrap configuration!
        </div>
        <div>{location.pathname}</div>
      </div>
    </Row>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default NoComponentSet;

// *******************************************************************************
// HELPERS
// *******************************************************************************
